/* eslint-disable import/no-extraneous-dependencies */
import { Box, styled } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import { t } from "i18next";
import { useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const SummaryTextArea = styled(Box, {
	shouldForwardProp: prop => prop !== "isExpanded"
})(({ theme, isExpanded, minHeight = "10vh", style = {} }) => {
	return {
		height: isExpanded ? "auto" : minHeight,
		padding: theme.spacing(1.5),
		backgroundColor: theme.palette.grey[50],
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		fontSize: "0.9rem",
		color: theme.palette.text.primary,
		overflowX: "auto",
		overflowY: isExpanded ? "visible" : "hidden",
		textOverflow: isExpanded ? "initial" : "ellipsis",
		lineHeight: 1.4,
		fontFamily: theme.typography.body1.fontFamily,
		whiteSpace: "pre-wrap",
		...style
	};
});

const TextDetails = ({ text, minHeight = "20vh", ...rest }) => {
	const [expanded, setExpanded] = useState(false);

	return (
		<MDBox>
			<SummaryTextArea isExpanded={expanded} minHeight={minHeight} style={{ ...rest }}>
				<Markdown remarkPlugins={[remarkGfm]}>{text}</Markdown>
			</SummaryTextArea>
			<MDBox
				mt={1}
				display="flex"
				justifyContent="flex-end"
				alignItems="center"
				sx={{ width: "100%" }}
			>
				<MDButton
					color="info"
					variant="text"
					size="small"
					onClick={e => {
						setExpanded(!expanded);
						e.stopPropagation();
						e.preventDefault();
					}}
				>
					{expanded ? t("SETTINGS.seeLess") : t("SETTINGS.seeMore")}
				</MDButton>
			</MDBox>
		</MDBox>
	);
};

export default TextDetails;
